export default __webpack_public_path__ + "static/media/report.3dede966.svg";